module.exports = __webpack_public_path__ + "static/abalone2.1ad3bfec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/blog/bikesgiving/abalone2.jpg
// module id = 477
// module chunks = 107818501498521